import type { Crew, EventLink, HaulLine, LogEntry, Op, OpSummary, People, Presence } from './schemas.ts';

// Ops' live topics (plan 2D Assumption 7).

/** Upcoming ops' summaries, and their removal: for ops.view_schedule. Nothing beyond OpSummary goes here. */
export const SCHEDULE_TOPIC = 'ops.schedule';

/** Every change to ops, crew, haul, the log, links and settlement: for ops.view. */
export const ALL_TOPIC = 'ops.all';

/** "People changed": pages re-read them. For ops.view_people. */
export const PEOPLE_TOPIC = 'ops.people';

/** "Reports changed": pages re-read them, as a report can pass a live message's 64 KB limit once it's JSON. For ops.view_reports. */
export const REPORTS_TOPIC = 'ops.reports';

/** An upcoming op changed. */
export interface SummaryChange {
  type: 'summary';
  op: OpSummary;
}

/** An op stopped being upcoming, or was deleted. */
export interface SummaryRemoved {
  type: 'summary_removed';
  id: string;
}

/** An op changed. */
export interface OpChange {
  type: 'op';
  op: Op;
  crewCount: number;
  people: People;
}

export interface OpRemoved {
  type: 'op_removed';
  id: string;
}

/** Crew joined or left an op. */
export interface CrewChange {
  type: 'crew';
  op: string;
  added: Crew[];
  removed: string[];
  crewCount: number;
  people: People;
}

/** Haul lines changed or went. */
export interface HaulChange {
  type: 'haul';
  op: string;
  lines: HaulLine[];
  removed: string[];
}

export interface LogChange {
  type: 'log';
  entry: LogEntry;
  people: People;
}

export interface LogRemoved {
  type: 'log_removed';
  op: string;
  id: string;
}

/** An op's link to its Discord event changed, or went. */
export interface LinkChange {
  type: 'link';
  op: string;
  link: EventLink | null;
}

/** Time in voice changed, for these people only: an op's whole list can be 200 rows. */
export interface PresenceChange {
  type: 'presence';
  op: string;
  rows: Presence[];
}

export interface PeopleChange {
  type: 'people';
}

export interface ReportsChange {
  type: 'reports';
}
